import axios from 'axios';

import { DATAMASTER_ENDPOINT } from '../../endpoints';

export async function getAllCategories() {
    try {
        const data = await axios.get(`${DATAMASTER_ENDPOINT}/getCategories`)

        return { data: data?.data?.categories || [] }
    } catch (error) {
        throw new Error(error)
    }
}
